export default theme => ({
  root: {
    bottom: theme.spacing(["5", 10]),
    [theme.breakpoints.up("xs")]: {
      position: "fixed",
      right: `5px`
    },
    [theme.breakpoints.down("xs")]: {
      position: "fixed",
      // alignSelf: "center",
      // right: theme.spacing(["4", 10]),
      // right: -40,
      right: `5px`,
      maxWidth: 340
    },
    zIndex: 1001
  }
});
